
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue"

type ModalBadge = {
  slug: string
  title: string
  progress: number
  actionsLabel: string
}

export default Vue.extend({
  name: "ProgressBenefitModal",
  emits: ["input"],
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    hint: { type: String, default: "" },
    footerHint: { type: String, default: "" },
    closeLabel: { type: String, default: "" },
    lockedLabel: { type: String, default: "" },
    badges: { type: Array as () => ModalBadge[], default: () => [] },
  },
})
